import {useState} from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import usePendingHandler from '@shared/usePendingHandler';
import {diApi} from '@di-shared/api/di';
import useApiError from '@di-shared/features/common/useApiError';
import {AgreeInfo, CustomerType, GetUbiThirdPartyTermsResponse} from '@di-shared/api/di/__generated';
import PreventForm from '@shared/PreventForm';
import DOMPurify from 'dompurify';

export interface UbiAgreeBottomSheetProps {
  vin: string;
  serviceId: string;
  termsData: GetUbiThirdPartyTermsResponse;
  agreeInfo: Array<AgreeInfo>;
  companyName: string;
}

function UbiAgreeBottomSheet({vin, serviceId, termsData, agreeInfo, companyName}: UbiAgreeBottomSheetProps) {
  const {t} = useInferableTranslation();
  const {resolveError} = useApiError();

  const [isTermsPage, setIsTermsPage] = useState(false);

  const [submitAgreeUbi] = usePendingHandler(
    async () => {
      await diApi.ubiThirdPartyAgreementsController.createCciAgreement({
        requestBody: {
          vin,
          serviceId,
          agreeInfo,
          customerType: CustomerType._1,
        },
      });
      window.bottomSheetClose(true);
    },
    async (error) => {
      await resolveError(error);
    }
  );

  return (
    <div className="bottom_sheet">
      {isTermsPage ? (
        <>
          <div className="bottom_sheet_header">
            <h2
              className="bottom_sheet_title"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T20216')}
            </h2>
            <button
              type="button"
              className="btn btn_ic"
              aria-label={t('T10017')}
              onClick={() => setIsTermsPage(false)}
            >
              <span
                className="ic ic_close_20px"
                aria-hidden="true"
              ></span>
            </button>
          </div>
          <div className="bottom_sheet_inner">
            <div
              className="bottom_sheet_contents"
              // [2025-07-11:dooking] FIXME: termsData 확인 필요
              dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(termsData.content || '')}}
            ></div>

            <div className="bottom_sheet_footer">
              <button
                type="submit"
                className="btn btn_large btn_filled"
                onClick={() => {
                  setIsTermsPage(false);
                }}
              >
                {t('T10114')}
              </button>
            </div>
          </div>
        </>
      ) : (
        <PreventForm onSubmit={submitAgreeUbi}>
          <div className="bottom_sheet_header">
            <h2
              className="bottom_sheet_title"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T20116')}
            </h2>
            <button
              type="button"
              className="btn btn_ic"
              aria-label={t('T10017')}
              onClick={() => window.bottomSheetClose(false)}
            >
              <span
                className="ic ic_close_20px"
                aria-hidden="true"
              ></span>
            </button>
          </div>
          <div className="bottom_sheet_inner">
            <div className="bottom_sheet_contents">
              <strong className="bottom_sheet_title_sub">{t('T20117')}</strong>
              <div className="consent_agree">
                <div className="divider"></div>
                <div className="consent_agree_item">
                  <p className="consent_agree_desc">{t('T20118_$company', {company: companyName})}</p>
                  <button
                    type="button"
                    className="btn btn_ic"
                    onClick={() => setIsTermsPage(true)}
                  >
                    <span
                      className="ic ic_arrow_forward_16px"
                      aria-hidden="true"
                    >
                      <span className="blind">{t('T10063')}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div className="bottom_sheet_footer bottom_sheet_footer_complex">
              <button
                type="button"
                className="btn btn_large btn_outline"
                onClick={() => window.bottomSheetClose(false)}
              >
                {t('T20119')}
              </button>

              <button
                type="submit"
                className="btn btn_large btn_filled"
              >
                {t('T20120')}
              </button>
            </div>
          </div>
        </PreventForm>
      )}
    </div>
  );
}

export default UbiAgreeBottomSheet;
